import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setDrawer } from 'store/entities/drawer/actions';
import { selectDrawer } from 'store/entities/drawer/selectors';
import { initialState } from 'store/entities/drawer';

interface UseFilterCleanupProps {
  isOverview: boolean;
  viewId: string;
  shouldPersistFilters?: boolean;
}

export function useFilterCleanup({ isOverview, viewId, shouldPersistFilters = false }: UseFilterCleanupProps) {
  const dispatch = useDispatch();
  const drawerState = useSelector(selectDrawer());

  useEffect(() => {
    if (shouldPersistFilters) {
      return () => {
        dispatch(
          setDrawer({
            ...drawerState,
            isOpen: false,
          })
        );
      };
    }

    return () => {
      dispatch(
        setDrawer({
          ...initialState,
          contentType: null,
          isOpen: false,
          dataSchema: null,
          appliedFilters: {},
          savedFilters: {},
          agendaId: '',
          viewId: '',
          entity: `userAgenda-${isOverview ? 'overview' : 'listing'}-${viewId}`,
        })
      );
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, isOverview, viewId, shouldPersistFilters]);
}
